<template>
  <div class="p-5 flex flex-col items-center h-screen overflow-y-auto">
    <div class="select-box">
      <DeviceSearchSelect placeholder="請選擇機台" @change="handleChange" />
    </div>
    <div class="flex text-center text-2xl border-2 border-blue-500 my-3 p-4 rounded-2xl gap-3 aaa">
      <div class="">
        截圖張數：
        <a-input-number id="inputNumber" v-model="page" :min="1" :max="10" />
        張
      </div>
      <div>-</div>
      <div class="">
        回傳圖檔間隔秒數：
        <a-input-number id="inputNumber" v-model="interval" :min="1" :max="10" />
        秒
      </div>
      <a-button :disabled="!mac" class="" @click="MqttScreenShot()" type="primary"> 點擊取得截圖 </a-button>
    </div>

    <div class="example-3d">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide v-for="(image, index) in screenShotImgArr" :key="index">
          <img class="img" :src="image" alt="Rendered Image" />
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="text-3xl">
      <span class=""
        >已回傳 <span class="text-red-600 font-extrabold text-4xl">{{ screenShotImgArr.length }}</span> 張，
      </span>
      <span v-if="screenShotImgArr.length === page">完成。</span>
      <span v-else>距離下張還有{{ countdown }}秒</span>
    </div>
  </div>
</template>

<script>
import DeviceSearchSelect from '@/components/DeviceSearchSelect.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  name: 'ScreenShot',

  data () {
    return {
      page: 3,
      interval: 3,
      countdown: null,
      flagAdd: 0,
      timer: null,
      mac: null,
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  },
  components: {
    DeviceSearchSelect,
    Swiper,
    SwiperSlide
  },
  computed: {
    screenShotImgArr: {
      get () {
        return this.$store.state.screenShotImgArr
      },
      set () {}
    },
    mqttClient: {
      get () {
        return this.$store.state.mqttClient
      },
      set () {}
    }
  },
  mounted () {
  },
  watch: {
    screenShotImgArr: {
      handler (newValue, oldValue) {
        // console.log(newValue.length)
        // console.log(oldValue.length)
        clearInterval(this.timer)
        this.countdown = this.interval
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown === 0) {
            clearInterval(this.timer)
          }
        }, 1000)
      }
    }
  },
  methods: {
    handleChange (mac) {
      this.mac = mac
    },
    MqttScreenShot () {
      this.flagAdd++
      this.$store.commit('flagAdd', this.flagAdd)
      const inf = JSON.stringify({
        page: this.page,
        interval: this.interval
      })
      // eslint-disable-next-line no-undef
      const message = new Paho.MQTT.Message(inf)
      message.destinationName = `command/${this.mac}/screenShot`
      //   message.destinationName = 'command/000732adab8b/screenShot'
      this.mqttClient.send(message)
    }
  }
}
</script>

<style scoped>
img {
  width: 100%;
  height: 100%;
}
.example-3d {
  /*   border: 1px solid black; */
  width: 800px;
  /*   padding-top: 50px; */
  /*   padding-bottom: 50px; */
}

.swiper {
  height: 100%;
  width: 100%;
}

.swiper .swiper-slide {
  border: 10px solid block;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 390px;
  height: 540px;
}

.aaa {
  width: fit-content;
}

.select-box {
  width: 240px;
}
</style>
